export const title1Size = {
  base: 28,
  wide: 36,
};

export const title2Size = {
  base: 16,
  wide: 28,
};
